// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"445":"ef9a0595","612":"d2a774bf","953":"1ce81d0d"}[chunkId] + ".chunk.css";
};